<template>
  <div>
    <validation-observer ref="form" tag="div">
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('manufactures.name'))"
          class="col-md-6"
          rules="required"
          vid="name"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('manufactures.name')) + '*'"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-form-input
              id="name"
              v-model="model.name"
              :state="errors[0] ? false : validated ? true : null"
              name="name"
              type="text"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('manufactures.short_name'))"
          class="col-md-6"
          vid="short_name"
      >

        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('manufactures.short_name'))"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-form-input
              id="short_name"
              v-model="model.short_name"
              :state="errors[0] ? false : validated ? true : null"
              name="short_name"
              type="text"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.upperFirst($t('manufactures.type'))"
          vid="type"
      >
        <b-form-group
            v-slot="{ ariaDescribedby }"
            :invalid-feedback="errors[0]"
            :label="`${lodash.upperFirst($t('manufactures.type'))}*`"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            content-cols-md="4"
            label-cols-md="12"
        >
          <b-form-radio-group
              id="radio-group-type"
              v-model="model.type"
              :aria-describedby="ariaDescribedby"
              name="type"
              :options="typeOptions"
          >
          </b-form-radio-group>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('manufactures.is_active'))"
          class="col-md-6"
          vid="is_active"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('manufactures.status'))"
            :state="errors[0] ? false : validated ? true : null"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-form-checkbox
              id="checkbox-1"
              v-model="model.is_active"
              name="is_active"
          >
            {{ lodash.upperFirst($t('manufactures.is_active')) }}
          </b-form-checkbox>
        </b-form-group>
      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import FormModel from "./model";

export default {
  extends: FormModel,
  components: {},
  data() {
    return {
      model: {
        ...this.value,
      },
      typeOptions: [
        {text: this.lodash.upperFirst(this.$t("manufactures.types.feed")), value: "feed"},
        {text: this.lodash.upperFirst(this.$t("manufactures.types.seed")), value: "seed"},
      ],
      segmentedButtons: [],
    };
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .custom-checkbox .custom-control-label::before {
    border-radius: 0.25rem;
  }

  .col-form-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #6c7589;
  }
}
</style>

<style lang="scss" scoped>
.section-title {
  font-weight: 800;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.05em;
  color: #0084f3;
}

::v-deep {
  table {
    thead {
      background: #f9fafb !important;
    }
  }

  .vs__selected-options input {
    padding: 4px 16px;
  }
}

.card-form {
  max-width: 720px;
}
</style>

<style lang="scss">
.vs__dropdown-menu {
  z-index: 9999 !important;
}

.button-add-bank {
  transition: background .2s ease-in;
  border-radius: 0;

  &:hover {
    background: #EEF3F7;
  }
}
</style>
